import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FaCircleCheck, FaArrowRight } from 'react-icons/fa6';

export default function CheckoutComplete() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('loading');
  const [name, setName] = useState(null);

  useEffect(() => {
    document.title = 'Purchase complete — Learning Outcomes Academy';
    return () => { document.title = 'Learning Outcomes Academy'; };
  }, []);

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }
    fetch(`/api/checkout/status?session_id=${encodeURIComponent(sessionId)}`, {
      credentials: 'include',
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.ok) {
          setName(data.name ? data.name.split(' ')[0] : null);
          setStatus('paid');
        } else {
          setStatus('error');
        }
      })
      .catch(() => setStatus('error'));
  }, [sessionId]);

  if (status === 'loading') {
    return (
      <div className="w-full bg-bone min-h-screen flex items-center justify-center">
        <div className="animate-pulse text-slate2 text-sm">Confirming your purchase…</div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="w-full bg-bone min-h-screen">
        <div className="container-page pt-20 pb-20 text-center max-w-lg mx-auto">
          <div className="eyebrow eyebrow-bar justify-center inline-flex mb-4">Purchase status</div>
          <p className="text-slate2 leading-relaxed mb-6">
            We couldn't confirm your payment status right now. If you completed checkout,
            check your email — your sign-in link is on its way.
          </p>
          <Link to="/courses/ai-for-parents" className="btn-link">
            Return to course page
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full bg-bone min-h-screen">
      <div className="container-page pt-16 pb-24 max-w-xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-moss/15 mb-6">
          <FaCircleCheck className="text-3xl text-brand-moss" />
        </div>
        <div className="text-[11px] tracking-[0.28em] uppercase text-brand-aubergine mb-3">
          You're enrolled
        </div>
        <h1 className="font-display text-3xl lg:text-4xl tracking-tighter2 text-ink mb-4">
          {name ? `Welcome, ${name}!` : 'Welcome aboard!'}
        </h1>
        <p className="text-slate2 leading-relaxed mb-2">
          Your purchase of <strong className="text-ink">Generative AI for Parents</strong> is confirmed.
        </p>
        <p className="text-slate2 leading-relaxed mb-8">
          We've sent a sign-in link to your email — click it to open Module&nbsp;1 immediately.
          The link works once and expires in 72 hours.
        </p>
        <div className="space-y-3">
          <Link
            to="/login"
            className="inline-flex items-center gap-2 btn-primary"
          >
            Sign in to start learning
            <FaArrowRight className="text-xs" />
          </Link>
          <div>
            <Link to="/courses/ai-for-parents" className="text-xs text-slate2 hover:text-ink underline underline-offset-2">
              Return to course page
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
